module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 3.9edfe253.png";